import React from "react";
import {formatPhoneNumber} from "../../../ts/common/SiteHelper";
import AppButton from "../../element/button/AppButton";

interface INameClass
{
    value:string;
    className?:string;
}

interface IProps
{
    name?:string;
    address?:INameClass[];
    telephoneNumber?:string;
    emailAddress?:string;
}

const OsmLocationMapView = (props: IProps) =>
{
    return <>
        <div className="marker">
            {!!props.name && <>
                <h3 className="marker-title">{props.name}</h3>
            </>}
            {!!(props.address ?? []).length && <>
                <div className="marker-address">

                    {props.address!.map((line, index) =>
                    {

                        return <span key={index} className={line.className ?? ""}>{line.value}</span>;
                    })}
                </div>
            </>}
            <div className="marker-contact">
                {!!props.telephoneNumber && <>
                    <span className="phone">
                        <AppButton href={"tel:"+formatPhoneNumber(props.telephoneNumber)} title="Telephone ">
                            <i className="fa fa-phone" aria-hidden="true"></i> {props.telephoneNumber}
                        </AppButton>
                    </span>
                </>}
                {!!props.emailAddress && <>
                    <span className="email">
                        <AppButton href={"mailto:"+props.emailAddress} title="Email fun@barrelsoffun.org.uk">
                            <i className="fa fa-envelope" aria-hidden="true"></i> {props.emailAddress}
                        </AppButton>
                    </span>
                </>}
            </div>
        </div>
    </>
}
export default OsmLocationMapView;